import React from 'react';
import './PageLoader.scss';
import msLogo from '../../../assets/images/home/msBlueLogo.svg';

const PageLoader = () => (
  <>
    <div className="page-loader-topbar" />
    <div className="page-loader-container">
      <img src={msLogo} alt="MillionSpaces" className="ms-logo" />
      <div className="loader-dots">
        <div className="dot" />
        <div className="dot" />
        <div className="dot" />
      </div>
    </div>
  </>
);

export default PageLoader;
